export default {
  default: 'th',
  SettingBot:{
    topic: 'ตั้งค่า Bot OnePlatform',
    addbot: 'เพิ่ม Bot',
    createbot: 'สร้าง Bot OnePlatform',
    botdata: 'ข้อมูล Bot',
    updatedata: 'อัพเดท Bot OnePlatform',
    updatebot: 'อัพเดท',
    deletebot: 'คุณต้องการลบเอกสารตั้งค่า Bot',
    botname: 'Bot',
    add_bot_success: 'เพิ่ม Bot สำเร็จ',
    edited:'แก้ไข Bot สำเร็จ'
  },
  BotOnePlatform:{
    create: 'สร้าง',
    create_bot: 'สร้างกลุ่ม Bot OnePlatform',
    group_sent_data: 'ข้อมูลกลุ่ม Bot OnePlatform',
    name: 'ชื่อ',
    hospital_name: 'ชื่อโรงพยาบาล',
    hospital_code: 'รหัสโรงพยาบาล',
    CreatedAt: 'วันที่สร้าง',
    UpdatedAt: 'วันที่แก้ไข',
    consent_list: 'รายการความยินยอม',
    choose_bot: 'เลือกบอท',
    choose_bot2: 'กรุณา เลือกบอท',
    template1: 'เลือก Template',
    template2: 'กรุณา เลือก Template',
    created: 'สร้าง Bot OnePlatform สำเร็จ'
  },
  Template:{
    setting:'ตั้งค่า Template Bot',
    add: 'เพิ่ม Template',
    create_template: 'สร้าง Template',
    template_data: 'ข้อมูล Template',
    update: 'แก้ไข Template',
    edited: 'แก้ไข Template สำเร็จ',
    add_success: 'เพิ่ม Template สำเร็จ'
  },
  Toolbar: {
    myRight: 'ตรวจสอบสิทธิตนเอง',
    'template-bot': 'ตั้งค่า Template Bot',
    consentlist: 'รายการความยินยอม',
    manageConsent: 'ขอสิทธิจากผู้อื่น',
    externalServices: 'เชื่อมต่อระบบภายนอก',
    general: 'ข้อมูลทั่วไป',
    logout: 'ออกจากระบบ',
    admin: 'ผู้ดูแลระบบ',
    usage: 'ข้อมูลการใช้งาน',
    policy: 'สร้างนโยบาย',
    consentform: 'สร้างความยินยอม',
    consent: 'ความยินยอม',
    mcg: 'จัดการกลุ่มความยินยอม',
    rconsent: 'ขอความยินยอม',
    email: 'อีเมล',
    emailseting: 'ตั้งค่าระบบ',
    smtp: 'ตั้งค่า SMTP อีเมล',
    tem: 'ตั้งค่า Template อีเมล',
    petition: 'คำร้องที่ถูกส่งถึง',
    policyData: 'ข้อมูลคำร้อง',
    detail: 'รายละเอียด',
    SearchConsent: 'ค้นหาความยินยอม',
    cookies: 'Cookies',
    ConsentOverview: 'ภาพรวมการใช้งาน',
    announce: 'แจ้งประกาศ',
    logosetting: 'ตั้งค่าโลโก้บริษัท',
    announceList: 'รายการประกาศ',
    bot:'ตั้งค่า Bot',
  },
  Login: {
    btnLogin: 'ลงชื่อเข้าใช้',
    TermsandConditions: 'ข้อตกลงและเงื่อนไขการให้บริการ',
    AccessVia: 'เข้าใช้งานผ่าน One Platform',
    or: 'หรือ',
    registerOne: 'สมัครเข้าใช้งาน One Platform',
    protectionpolicy: 'นโยบายคุ้มครองข้อมูลส่วนบุคคล',
    detailEmail: 'หรือ ลงชื่อเข้าใช้ด้วย',
    loginEmail: 'อีเมล (ใช้สำหรับบริการอีเมลเท่านั้น)'
  },
  Profile: {
    userData: 'ข้อมูลผู้ใช้งาน',
    accountId: 'หมายเลขบัญชีผู้ใช้งาน',
    username: 'ชื่อผู้ใช้งาน',
    nameTh: 'ชื่อ-นามสกุล (ไทย)',
    nameEng: 'ชื่อ-นามสกุล (อังกฤษ)',
    email: 'อีเมล (One Platform)',
    Phone: 'เบอร์โทร',
    namesurname: 'ชื่อ-นามสกุล',
    company: 'ข้อมูลบริษัท',
    companyname: 'ชื่อบริษัท',
    corporateaccount: 'บัญชีนิติบุคคล',
    corporatenumber: 'เลขนิติบุคคล',
    activationdate: 'วันที่เปิดใช้งาน',
    forserviceAPIs: '(สำหรับ Service API)',
    SyncOneID: 'ซิงค์ ONEID',
    editemail: 'แก้ไขอีเมล',
    editphone: 'แก้ไขเบอร์โทร',
    checkphone: 'กรุณากรอก เบอร์โทรศัพท์',
    tel10: 'ต้องมีจำนวนตัวเลขอย่างน้อย 10 หลัก',
    pictext: 'เลือกรูปภาพ',
    pictext2: 'ไฟล์ที่ต้องการอัปโหลด',
    pictext3: 'รูปภาพควรมีขนาดควรน้อยกว่า 1 MB',
    fileUpload: 'แนบเอกสารประกอบคำร้อง',
    NoteLogo: '* โลโก้จะแสดงบนเนื้อหาต่างๆของระบบ CMP'
  },
  consentlist: {
    Specifysearchconditions: 'ระบุเงื่อนไขการค้นหา',
    allconsent: 'ความยินยอมทั้งหมด',
    waitConsent: 'รอให้ความยินยอม',
    ExpireConsent: 'ความยินยอมที่หมดอายุ',
    PetitionConsent: 'คำร้องขอความยินยอม',
    generalconsent: 'ความยินยอมทั่วไป',
    groupconsent: 'ความยินยอมแบบกลุ่ม',
    submission: 'วันที่ให้ความยินยอม',
    rulesubmission: 'กรุณาเลือก วันที่ส่งเอกสาร',
    rulesStatusConsent: 'กรุณาเลือก สถานะ',
    to: 'ถึง',
    ruleto: 'กรุณาเลือก วันที่ส่งเอกสาร ถึง',
    rulessystem: 'กรุณาเลือก Source System',
    search: 'ค้นหา',
    searchname: 'ค้นหาด้วยชื่อ',
    searchgroup: 'ค้นหาด้วยชื่อ หรือ ไอดี',
    fullconsentlist: 'รายการทั้งหมด',
    approved: 'ให้ความยินยอม',
    rejected: 'ปฏิเสธความยินยอม',
    ActiveConsent: 'ความยินยอมที่ใช้งาน',
    ActionConsent: 'ยื่นคำร้อง/คำร้องขอความยินยอม',
    CancelConsent: 'ถอนความยินยอม',
    list: 'รายการ',
    copy: 'คัดลอก',
    pic: 'แก้ไขรูปภาพ',
    detail: 'ดูรายละเอียด',
    did: 'เลขเอกสาร',
    Cnumber: 'เลขเอกสารความยินยอม',
    type: 'ประเภท',
    subject: 'หัวข้อความยินยอม',
    data: 'ข้อมูลที่ขอ',
    topic: 'นโยบาย',
    ConsentName: 'กลุ่ม/ความยินยอม',
    Tag: 'ข้อมูลที่ขอ',
    Name: 'ชื่อ ​(OneId)',
    Tel: 'เบอร์โทรศัพท์',
    Email: 'อีเมล',
    Idcard: 'เลขบัตรประชาชน 13 หลัก',
    Passport: 'หนังสือเดินทาง',
    organization: 'องค์กร',
    date: 'วันที่ส่ง',
    expiration: 'วันที่หมดอายุ',
    choice: 'ตัวเลือก',
    choicedetail: 'รายละเอียด',
    groupName: 'หัวข้อกลุ่มความยินยอม',
    cancleBtn: 'ยกเลิก',
    petitionBtn: 'ยื่นคำร้อง',
    active: 'พร้อมใช้งาน',
    pending: 'รอดำเนินการ',
    inactive: 'ไม่พร้อมใช้งาน',
    infomation: 'ข้อมูลส่วนบุคคล',
    groupSend: 'กลุ่ม',
    NameShow: 'ชื่อที่ได้ระบุ',
    NameReq: 'ชื่อผู้ขอ',
    DateApprove: 'วันที่ดำเนินการ',
    status1: 'กำลังใช้งาน',
    status2: 'ยื่นคำร้องสำเร็จ',
    status3: 'แจ้งวันที่ดำเนินการคำร้อง',
    status4: 'คำร้องได้รับการอนุมัติ',
    ItemsStatus: [
      { text: 'พร้อมใช้งาน', value: 'active' },
      { text: 'รอดำเนินการ', value: 'pending' },
      { text: 'ไม่พร้อมใช้งาน', value: 'inactive' }
    ],
    ItemsStatusConsent: [
      { text: 'ทั้งหมด', value: 'null' },
      { text: 'กำลังใช้งาน', value: 'active' },
      { text: 'รอดำเนินการ', value: 'pending' },
      { text: 'ยกเลิก', value: 'unactive' },
      { text: 'หมดอายุ', value: 'expire' },
      { text: 'มีการยื่นคำร้อง', value: 'action' },
      { text: 'ถอนความยินยอม', value: 'petition' }
    ],
    all: [
      { text: 'ทั้งหมด', value: 'null' },
      { text: 'API', value: 'API' },
      { text: 'Onechat', value: 'ONECHAT' },
      { text: 'Email', value: 'EMAIL' },
      { text: 'Webscript', value: 'Webscript' },
      { text: 'Qrcode', value: 'Qrcode' }
    ],
    UserId: 'เลขบัตรประจำตัวประชาชน',
    groupC: 'กลุ่มความยินยอม'
  },
  dashboard: {
    total: 'ความยินยอมทั้งหมด',
    all: 'ทั้งหมด',
    issue: 'ฉบับ',
    app: 'ยินยอมแล้ว',
    reject: 'ไม่ยินยอม',
    pen: 'รอตอบกลับ',
    generalType: 'แบบทั่วไป',
    groupType: 'แบบกลุ่ม',
    generalsub: 'จำนวนการส่งแบบทั่วไป',
    groupsub: 'จำนวนการส่งแบบกลุ่ม',
    list: 'รายการ',
    permonth: 'จำนวนความยินยอม ต่อเดือน',
    subject: 'หัวข้อความยินยอม',
    cby: 'ดำเนินการโดย',
    use: 'จำนวนการใช้งาน',
    detail: 'รายละเอียด',
    num: 'ลำดับ',
    name: 'ชื่อ',
    email: 'อีเมล',
    create: 'วันที่ทำรายการ',
    detailtable: 'รายละเอียดรายการที่ส่ง',
    status: 'สถานะ',
    statusapp: 'ยินยอม',
    statusreject: 'ปฏิเสธ',
    statuspen: 'รอตอบกลับ',
    gconsentdetail: 'รายละเอียดความยินยอม',
    groupconsentdetail: 'รายละเอียดความยินยอมแบบกลุ่ม',
    consentdetail: 'รายละเอียดความยินยอม',
    cor: 'ข้อมูลองค์กร',
    policy: 'นโยบาย',
    org: 'องค์กรที่ขอความยินยอม',
    consentAll: 'ความยินยอมทั้งหมด',
    logEmail: 'ข้อมูลการใช้งาน อีเมล',
    count: 'จำนวน',
    sendConsent: 'ส่งความยินยอม',
    sendConsentStatus: 'ส่งความยินยอมสำเร็จ',
    sendEmail: 'ส่งอีเมล',
    testEmail: 'ทดสอบส่งอีเมล',
    alert: 'แจ้งเตือน',
    approved: 'ยินยอม',
    upapproved: 'ปฏิเสธ',
    NumMonth: { text: 'ทั้งหมด', value: 0 },
    CountMonth: [
      { text: 'ทั้งหมด', value: 0 },
      { text: '1 เดือน', value: 1 },
      { text: '3 เดือน', value: 3 },
      { text: '6 เดือน', value: 6 },
      { text: '12 เดือน', value: 12 }
    ],
    expire: 'หมดอายุ'
  },
  policyForm: {
    crpolicy: 'สร้างนโยบาย',
    allpo: 'นโยบายทั้งหมด',
    poid: 'หมายเลขนโยบาย',
    led: 'วันที่ (เพิ่ม/แก้ไข)',
    select: 'ตัวเลือก',
    detail: 'รายละเอียดนโยบาย',
    policyin: 'ข้อมูลนโยบาย',
    psps: 'กรุณาระบุหัวข้อนโยบาย',
    pspd: 'กรุณากรอก รายละเอียดนโยบาย',
    save: 'บันทึก'
  },
  footer: {
    contact:
      'หากพบปัญหาการใช้งาน กรุณาติดต่อ อีเมล: nockkc@inet.co.th หรือ โทร. 02-026-2041',
    Privacy: 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล',
    notice: 'ประกาศนโยบายความเป็นส่วนตัว'
  },
  consentform: {
    consent: 'ความยินยอมทั้งหมด',
    title: 'ข้อมูลความยินยอม',
    allconsent: 'เอกสารขอความยินยอมทั้งหมด',
    callconsent: 'สร้างความยินยอม',
    consentid: 'หมายเลขเอกสารความยินยอม',
    subject: 'หัวข้อ',
    add: 'วันที่ (เพิ่ม/แก้ไข)',
    open: 'เปิด',
    off: 'ปิด',
    detail: 'รายละเอียดเอกสารความยินยอม',
    agree: 'รายละเอียดหากไม่ยินยอม',
    organ: 'องค์กร',
    create: 'ผู้สร้างเอกสารความยินยอม',
    age: 'อายุเอกสาร (ปี)',
    age2: 'ปี',
    consentcr: 'สร้างความยินยอม',
    consented: 'แก้ไขความยินยอม',
    speconsent: 'ระบุความหัวข้อยินยอมเรื่อง',
    sepconsent2: 'กรุณากรอก ระบุความยินยอมเรื่อง',
    exdate: 'วันที่หมดอายุ (ระบุเป็นจำนวนปี)',
    exdate2: 'กรุณากรอก จำนวนปี',
    brief: 'รายละเอียดความยินยอมแบบย่อ',
    brief2: 'กรุณากรอก รายละเอียดความยินยอมแบบย่อ',
    brief3: 'กรอกได้ไม่เกิน 500 ตัว',
    head: 'ความยินยอมเรื่อง :',
    pdf: 'ดาวน์โหลดไฟล์ PDF',
    edit: 'แก้ไขหมายเลขเอกสารความยินยอม (Update)',
    edit2: 'กรุณากรอก หมายเลขเอกสารความยินยอม (Update)',
    close: 'ปิด'
  },
  mcg: {
    gcm: 'กลุ่มความยินยอมทั้งหมด',
    organgroup: 'สร้างกลุ่มความยินยอม',
    cregroup: 'สร้างกลุ่ม',
    row1: 'หมายเลขกลุ่ม',
    row2: 'ชื่อกลุ่มความยินยอม',
    row3: 'ดำเนินการโดย',
    row4: 'วันที่ (เพิ่ม/แก้ไข)',
    row5: 'ตัวเลือก',
    add: 'เพิ่มกลุ่มความยินยอม',
    edit: 'แก้ไขกลุ่มความยินยอม',
    addinfor: 'ข้อมูลสำหรับเพิ่มกลุ่ม',
    editinfor: 'ข้อมูลสำหรับแก้ไขกลุ่ม',
    spegroupname: 'ระบุชื่อกลุ่ม',
    spegroupname2: 'กรุณากรอก ระบุชื่อกลุ่ม',
    policy1: '(เลือกได้เพียง 1 นโยบาย)',
    policy2: 'เลือกนโยบาย',
    policy3: 'กรุณากรอก นโยบาย',
    example: 'ตัวอย่าง',
    consent1: '(เลือกได้มากกว่า 1 ความยินยอม)',
    consent2: 'เลือกความยินยอม',
    consent3: 'กรุณาเลือก ความยินยอม',
    gdi: 'ข้อมูลรายละเอียดกลุ่ม',
    cgd: 'รายละเอียดกลุ่มความยินยอม'
  },
  onechat: {
    step1: 'ขั้นตอนที่ 1/2',
    step2: 'ขั้นตอนที่ 2/2',
    set: 'กำหนดสิทธิ์',
    con1: 'ค้นหารายชื่อ',
    con2: 'แผนก/ตำแหน่ง',
    con3: 'ทั้งหมด',
    con4: 'รหัสพนักงาน',
    text1: 'เลือกแผนก',
    text2: 'กรุณาเลือกแผนก',
    text3: 'เลือกตำแหน่ง',
    text4: 'กรุณาเลือกตำแหน่ง',
    consentlist: 'รายชื่อสำหรับส่งความยินยอม',
    consentlist2: 'ยืนยันรายชื่อสำหรับส่งความยินยอม',
    nameSur: 'ชื่อ - นามสกุล',
    add: 'เพิ่มรายชื่อ',
    name: 'ชื่อ-นามสกุล',
    all1: 'ทุกแผนก',
    all2: 'ทุกตำแหน่ง',
    next: 'ถัดไป',
    back: 'กลับ',
    send: 'ส่งความยินยอม',
    send2: 'ส่ง',
    text5: 'เลือกนโยบายและความยินยอม',
    text6: 'ส่งแบบทั่วไป',
    text7: 'ส่งแบบกลุ่ม',
    text8: 'เลือกนโยบายแบบทั่วไป',
    text9: 'เลือกความยินยอมแบบทั่วไป',
    text10: 'เลือกความยินยอมแบบกลุ่ม',
    date: 'วันที่ทำรายการ',
    status: 'สถานะ',
    status1: 'ยินยอม',
    status2: 'ไม่ยินยอม',
    status3: 'ส่งไม่สำเร็จ',
    status4: 'ส่งสำเร็จ',
    status5: 'เปิดอ่านแล้ว',
    status6: 'ดูเพิ่มเติม',
    status7: 'รอตอบกลับ',
    status8: 'ยังไม่ได้ส่ง',
    statusSendMail: 'ส่งสำเร็จ',
    Note: 'หมายเหตุ',
    oneid: 'หมายเลขการส่ง OnePlatform',
    titleNameTh: 'คำนำหน้า ภาษาไทย',
    titleNameEng: 'คำนำหน้า ภาษาอังกฤษ',
    nameTh: 'ชื่อ-นามสกุล ภาษาไทย',
    nameEng: 'ชื่อ-นามสกุล ภาษาอังกฤษ',
    textGroupSend: 'กรอกชื่อกลุ่ม',
    showPolicy: 'เลือกแสดงนโยบาย',
    show: 'แสดง',
    hide: 'ซ่อน',
    new1: 'รายชื่อข้อมูลจาก One ID',
    new2: 'รายชื่อข้อมูลจากระบบ CMP',
    new3: 'ส่งความยินยอม',
    groupconsent: 'กลุ่มการส่งความยินยอม',
    new4: 'ชื่อกลุ่มที่ส่ง',
    new5: 'คน',
    new6: 'จำนวนผู้รับ',
    nameSelect: 'รายชื่อที่เลือก',
    editName: 'แก้ไขรายชื่อ',
    statusSearch: 'ค้นหา สถานะการส่ง'
  },
  email: {
    text1: 'Email',
    text2: 'ดาวน์โหลด Template Excel',
    text3: 'คลิกหรือลากไฟล์ของคุณมาไว้ในพื้นที่นี่เพื่ออัปโหลด',
    text4: 'ไฟล์ที่รองรับ: Excel',
    text4pdf: 'ไฟล์ที่รองรับ: PDF, JPG, JEPG, PNG, BMP, SVG, WEBP',
    text5: 'ส่งเอกสารขอความยินยอมภายนอก',
    text6: 'ลบไฟล์',
    text7: 'ยืนยัน',
    text8: 'ชื่อ สกุล',
    text9: 'กรุณากรอก ชื่อ',
    text10: 'อีเมล',
    text11: 'กรุณากรอก อีเมล',
    text12: 'ล้างค่า',
    text13: 'เพิ่มอีเมล',
    step1: 'ขั้นตอนที่ 1/3',
    step2: 'ขั้นตอนที่ 2/3',
    step3: 'ขั้นตอนที่ 3/3',
    textTemplate: 'เลือก Template อีเมล',
    TemplateEmail: 'ชื่อ Template อีเมล',
    SendId: 'รหัสการส่ง',
    ListSend: 'รายการส่งความยินยอม',
    ListCheck: 'ตรวจสอบสถานะการส่งความยินยอม',
    Note: 'สามารถอัปโหลดไฟล์ Excel ได้เพียงครั้งละ 1 ไฟล์',
    Notepdf: 'สามารถอัปโหลดไฟล์ได้เพียงครั้งละ 1 ไฟล์',
    Comment:
      ' หมายเหตุ : กรุณาทำรายการด้านล่าง เพื่อดำเนินการขอความยินยอมผ่านอีเมล',
    Commentpdf: ' หมายเหตุ : กรุณาทำรายการด้านล่าง เพื่อดำเนินการอัปโหลดเอกสาร',
    statusSend: 'ทดสอบส่งอีเมล สำเร็จ',
    itemsConsentHeader: [
      {
        Text: 'ชื่อองค์กร',
        Value: '{{BUSINESS-NAME}}'
      },
      {
        Text: 'หมายเลขเอกสารนโยบาย',
        Value: '{{POLICY-ID}}'
      },
      {
        Text: 'หัวข้อนโยบาย',
        Value: '{{POLICY-HEADER}}'
      },
      {
        Text: 'ชื่อผู้รับ',
        Value: '{{NAME-TO}}'
      },
      {
        Text: 'อีเมลผู้รับ',
        Value: '{{EMAIL-TO}}'
      },
      {
        Text: 'หมายเลขเอกสารความยินยอม',
        Value: '{{CONSENT-ID}}'
      },
      {
        Text: 'หัวข้อความยินยอม',
        Value: '{{CONSENT-HEADER}}'
      },
      {
        Text: 'หัวข้อความยินยอมแบบกลุ่ม',
        Value: '{{CONSENT-GROUP}}'
      },
      {
        Text: 'ข้อมูลที่ต้องการขอ',
        Value: '{{REQ-TAG}}'
      },
      {
        Text: 'ชื่อผู้ส่งความยินยอม',
        Value: '{{SENDER-NAME}}'
      }
    ],
    itemsConsentDetail: [
      {
        Text: 'โลโก้องค์กร',
        Value: '{{LOGO}}'
      },
      {
        Text: 'ชื่อองค์กร',
        Value: '{{BUSINESS-NAME}}'
      },
      {
        Text: 'หมายเลขเอกสารนโยบาย',
        Value: '{{POLICY-ID}}'
      },
      {
        Text: 'หัวข้อนโยบาย',
        Value: '{{POLICY-HEADER}}'
      },
      {
        Text: 'รายละเอียดนโยบาย',
        Value: '{{POLICY-DETAIL}}'
      },
      {
        Text: 'ชื่อผู้รับ',
        Value: '{{NAME-TO}}'
      },
      {
        Text: 'อีเมลผู้รับ',
        Value: '{{EMAIL-TO}}'
      },
      {
        Text: 'หมายเลขเอกสารความยินยอม',
        Value: '{{CONSENT-ID}}'
      },
      {
        Text: 'หัวข้อความยินยอม',
        Value: '{{CONSENT-HEADER}}'
      },
      {
        Text: 'รายละเอียดให้ความยินยอม',
        Value: '{{CONSENT-DETAIL}}'
      },
      {
        Text: 'หัวเรื่องย่อ',
        Value: '{{CONSENT-HEADER-SHORT}}'
      },
      {
        Text: 'รายละเอียดปฏิเสธความยินยอม',
        Value: '{{CONSENT-REJECT}}'
      },
      {
        Text: 'หัวข้อความยินยอมแบบกลุ่ม',
        Value: '{{CONSENT-GROUP}}'
      },
      {
        Text: 'ข้อมูลที่ต้องการขอ',
        Value: '{{REQ-TAG}}'
      },
      {
        Text: 'ชื่อผู้ส่งความยินยอม',
        Value: '{{SENDER-NAME}}'
      },
      {
        Text: 'ปุ่มตรวจสอบความยินยอม',
        Value: '{{BUTTON-CHECK}}'
      }
    ],
    itemsConsentBtn: [{ value: '{{ButtonCheck}}', text: 'ปุ่มตรวจสอบ' }],
    status: [
      { text: 'ทั้งหมด', value: '' },
      { text: 'อ่านแล้ว', value: 'Read' },
      { text: 'ส่งสำเร็จ', value: 'OK' },
      { text: 'รอการตอบกลับ', value: 'WAIT' }
    ],
    statusUpload: [
      { text: 'ทั้งหมด', value: '' },
      { text: 'เปิดการใช้งาน', value: 'active' },
      { text: 'ปิดการใช้งาน', value: 'unactive' },
      { text: 'หมดอายุ', value: 'expire' }
    ],
    mailid: 'หมายเลขการส่งอีเมล'
  },
  smtp: {
    text1: 'ตั้งค่า SMTP อีเมล',
    text2: 'ข้อมูล SMTP',
    text3: 'เพิ่มข้อมูล SMTP',
    text4: 'เปิดใช้งาน',
    text5: 'แก้ไขข้อมูล',
    text6: 'ลบข้อมูล',
    text7: 'เปิดใช้งาน SMTP',
    text8: 'แก้ไขข้อมูล SMTP',
    text9: 'คุณต้องการลบเอกสารตั้งค่า SMTP อีเมล',
    text10: 'ใช่หรือไม่',
    text11: 'ยกเลิก',
    text12: 'ตกลง'
  },
  template: {
    text1: 'ตั้งค่า Template อีเมล',
    text2: 'เพิ่ม Template อีเมล',
    text3: 'ข้อมูลตั้งค่า Template อีเมล',
    text4: 'ชื่อ Template',
    text5: 'กรุณากรอกชื่อ',
    text6: 'หัวข้อ อีเมล',
    text7: 'รูปแบบ template',
    text8: 'เพิ่ม Template',
    text9: 'แก้ไข Template อีเมล',
    text10: 'แก้ไข Template',
    text11: 'คุณต้องการลบเอกสารตั้งค่า Template อีเมล',
    text12: 'หัวข้อนโยบาย',
    text13: 'อัปโหลดสำเร็จ',
    text14: 'อัปโหลดไม่สำเร็จ',
    text15: 'ทดสอบส่ง อีเมล',
    text16: 'เลือกส่วนที่ต้องการแสดงข้อมูล',
    text17: 'หัวข้อ',
    text18: 'เนื้อหา',
    text19: 'ข้อมูล',
    text20: 'ปุ่มตรวจสอบ',
    text21: 'ยังไม่ได้ตรวจสอบ',
    text22: 'ตรวจสอบแล้ว',
    text23: 'รายละเอียด Template อีเมล'
  },
  alert: {
    contactserve: 'ไม่สามารถติดต่อเซิฟเวอร์ได้',
    imgupload: 'อัปโหลดรูปสำเร็จ',
    login: 'เข้าสู่ระบบสำเร็จ',
    upload: 'อัปโหลด',
    success: 'เรียบร้อย',
    csv: 'โปรดเลือกไฟล์ xlsx',
    check: 'ขนาดไฟล์ไม่เกิน 5 MB',
    del: 'ลบไฟล์',
    confirm: 'ยืนยันข้อมูลเรียบร้อย',
    list: 'คุณได้บันทึกรายการเรียบร้อยแล้ว',
    one: 'ส่ง Onechat สำเร็จ',
    tem: 'แก้ไข template สำเร็จ',
    temadd: 'เพิ่ม template สำเร็จ',
    upconsent: 'อัพเดทความยินยอมสำเร็จ',
    uppolicy: 'อัพเดทนโยบายสำเร็จ',
    upgroup: 'อัพเดทความยินยอมแบบกลุ่มสำเร็จ',
    catch: 'ไม่พบ DepartmentId',
    email: 'ส่งอีเมลซ้ำ สำเร็จ'
  },
  overlay: {
    load: 'กำลังดาวน์โหลดข้อมูล ...',
    checkRole: 'ไม่มีสิทธิเข้าถึงเมนู'
  },
  title: {
    cmp1: 'เข้าสู่ระบบ | CMP'
  },
  landingpage_404: {
    title: 'ขออภัย ไม่พบหน้าเว็บไซต์',
    subTitle: 'กลับไปที่ uatcmp.one.th'
  },
  dashboardUser: {
    sendall: 'ส่งทั้งหมด',
    generalsend: 'ส่งแบบทั่วไป',
    groupsend: 'ส่งแบบกลุ่ม',
    Totalmonth: 'จำนวนความยินยอม ต่อเดือน',
    Totalconsent: 'ความยินยอมทั้งหมด',
    list: 'รายการ',
    all: 'ทั้งหมด',
    statusapp: 'ยินยอม',
    statusreject: 'ปฏิเสธ',
    statuspen: 'รอตอบกลับ'
  },
  petition: {
    text1: 'วันที่ส่งคำร้อง',
    text2: 'ขอคำร้อง',
    text3: 'เคยส่งคำร้องแล้ว',
    text4: 'คำร้องที่ถูกส่งถึง',
    text5: 'รายละเอียดคำร้อง',
    text6: 'องค์กร',
    text7: 'ประเภทคำร้อง',
    text8: 'รายละเอียดคำขอ',
    text9: 'ข้อมูลที่ต้องการดำเนินการ',
    text10: 'รายละเอียด',
    text11: 'ยื่นคำร้อง',
    text12: 'สร้างเมื่อ',
    text13: 'แก้ไขล่าสุด',
    text14: 'สถานะ',
    text15: 'ยืนยันตัวเลือก',
    text16: 'ปฏิเสธ',
    text17: 'รอตรวจสอบ (ผู้ส่งความยินยอม)',
    text18: 'คำร้องขอหมายเลข',
    text19: 'ชื่อ นามสกุล',
    text20: 'หัวข้อนโยบาย',
    text21: 'หัวข้อความยินยอม',
    text22: 'กำลังใช้งาน / คำร้อง',
    text22v2: 'กำลังใช้งาน',
    text23: 'ยกเลิก',
    text24: 'รอดำเนินการ',
    text37: 'หมดอายุ',
    text25:
      'กรุณาชี้แจงเหตุผลประกอบในการร้องขอให้ดำเนินการขอเข้าถึงข้อมูลส่วนบุคคลของเจ้าของข้อมูล พร้อมทั้งข้อมูล เอกสาร ข้อมูล หลักฐานประกอบเพื่อให้ผู้รับผิดชอบพิจารณาและ ดำเนินการตามสิทธิของท่านต่อไป',
    text26: 'เหตุผลที่ขอดำเนินการ และเหตุผลประกอบคำร้อง',
    text27: 'ชนิดคำร้อง',
    text28: 'รายการข้อมูลที่ขอดำเนินการ',
    text29: 'ชื่อ',
    text30: 'นามสกุล',
    text31: 'เบอร์โทรศัพท์ (10 หลัก)',
    text32: 'อีเมล',
    text33: 'ด้วยเหตุผลดังต่อไปนี้',
    DocApi: 'เอกสาร API',
    textName: 'ชื่อผู้ขอ',
    textType: 'ประเภทความยินยอม',
    listtext: [
      { text: '1. ประสงค์ถอนความยินยอม' },
      { text: '2. ประสงค์ ส่ง/โอนข้อมูลไปต่างประเทศ' },
      { text: '3. ประสงค์เข้าถึง/ขอรับสำเนา' },
      { text: '4. ประสงค์ให้เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคล' },
      {
        text: '5. ประสงค์ให้ผู้ควบคุมข้อมูลส่วนบุคคลโอนข้อมูลไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น'
      },
      {
        text: '6. ประสงค์ขอรับข้อมูลส่วนบุคคลเพื่อส่งให้ควบคุมข้อมูลส่วนบุคคลอื่น'
      },
      { text: '7. ประสงค์ทำลายข้อมูล' },
      { text: '8. ประสงค์ระงับการใช้ข้อมูลส่วนบุคคล' },
      { text: '9. ประสงค์ดำเนินการให้ข้อมูลเป็นปัจจุบันและสมบูรณ์' },
      { text: 'TEST' }
    ],
    text34: 'กรุณาเลือกชนิดคำร้อง',
    text35: 'หมายเลขคำร้อง',
    text36: 'หัวข้อคำร้อง',
    text38: 'คำร้องรอการตอบกลับ',
    text39: 'คำร้องได้รับการตอบกลับ',
    text40: 'วันที่',
    text41: 'เวลา',
    text42: 'ผู้อนุมัติคำร้อง',
    text43: 'กรุณาเลือกเลือกผู้อนุมัติคำร้อง',
    text44: 'มีการยื่นคำร้อง',
    text45: 'ถอนความยินยอม',
    all: 'ทั้งหมด',
    approve: 'อนุมัติ',
    wait: 'รอดำเนินการ'
  },
  seting: {
    text1: 'ตั้งค่าสิทธิ์เมนู',
    text2: 'ชื่อเมนู',
    text3: 'วันที่สร้าง',
    text4: 'การใช้งาน',
    text5: 'เปิดใช้งาน',
    text6: 'ปิดใช้งาน'
  },
  smtpemailadd: {
    text1: 'รูปแบบของ Host ไม่ถูกต้อง'
  },
  policy: {
    text1: 'ฉบับร่าง',
    text2: 'เปิดใช้งาน',
    text3: 'ปิดใช้งาน',
    text4: 'แก้ไขนโยบาย',
    text5: 'บันทึกฉบับร่าง',
    text6: 'บันทึก',
    text7: 'สถานะการใช้งาน',
    text8: 'บันทึกฉบับร่างสำเร็จ',
    text9: 'บันทึกและเปิดใช้งาน',
    text10: 'บันทึกเพื่อเปิดใช้งาน'
  },
  Cookies: {
    addData: 'ลงทะเบียนผู้ใช้งานระบบ',
    consent: 'เอกสารความยินยอม',
    editData: 'แก้ไขข้อมูลโดเมน',
    detail: 'รายละเอียดระบบ',
    type: 'ประเภท',
    general: 'แบบทั่วไป',
    group: 'แบบกลุ่ม',
    Consentnumber: 'หมายเลขเอกสารความยินยอม',
    Policynumber: 'หมายเลขเอกสารนโยบาย',
    groupnumber: 'หมายเลขเอกสารความยินยอมแบบกลุ่ม',
    text1: 'ลงทะเบียนโดเมน',
    text2: 'กรอกข้อมูลระบบ',
    text3: 'ชื่อระบบ',
    text4: 'ชื่อโดเมน',
    del: 'คุณต้องการลบ',
    firstStep: 'ขั้นตอนที่ 1',
    copyScript: 'คัดลอก Script ข้างใต้ไป',
    addPage: 'ใส่ยังหน้าที่คุณต้องการใช้งาน',
    secondStep: 'ขั้นตอนที่ 2',
    inputUserId: 'กรอก USERID ของระบบของคุณ',
    rowInput: 'ในช่องของ',
    thirdStep: 'ขั้นตอนที่ 3',
    finish: 'เสร็จสิ้น',
    ruleUsetId: 'กรุณากรอก User ID',
    or: 'หรือ'
  },
  search: {
    text1: 'ดาวน์โหลดรายงาน',
    creategroup:'สร้างกลุ่ม'
  },
  upload: {
    name: 'ชื่อ',
    tel: 'เบอร์โทร',
    email: 'อีเมล',
    next: 'ถัดไป',
    back: 'กลับ',
    upload: 'อัปโหลดเอกสาร',
    status: 'ยินยอม / ไม่ยินยอม',
    swal1: 'คุณแน่ใจหรือไม่ ?',
    swal2: 'กำลังทำการอัปโหลดเอกสาร!',
    swal3: 'ยืนยัน',
    swal4: 'ยกเลิก',
    swal5: 'โปรดเลือกข้อมูลให้เรียบร้อย',
    swal6: 'โปรดเลือกชนิดไฟล์ให้ถูกต้อง',
    swal7: 'โปรดกรอกข้อมูลอย่างน้อย 1 รายการ',
    swal8: 'สำเร็จ!',
    swal9: 'อัปโหลดเอกสารเรียบร้อย',
    text1: 'ชื่อความยินยอมแบบย่อ',
    text2: 'สร้างโดย',
    text3: 'วันที่หมดอายุ',
    text4: 'รายละเอียดความยินยอม',
    text5: 'รายละเอียดหากไม่ยินยอม',
    text6: 'ปิด',
    text7: 'ปี'
  },
  oneAccount: {
    text1: 'อัปโหลด Excel',
    text2: 'ดาวน์โหลด Template Xlsx',
    text3: 'คลิกหรือลากไฟล์ของคุณมาไว้ในพื้นที่นี่เพื่ออัปโหลด',
    text4: 'ไฟล์ที่รองรับ: xls, xlsx',
    text5: 'ไฟล์ที่รองรับ: xlsx',
    Note: 'สามารถอัปโหลดไฟล์ Excel ได้เพียงครั้งละ 1 ไฟล์',
    excel: 'โปรดเลือกไฟล์ xls, xlsx',
    check: 'ขนาดไฟล์ไม่เกิน 5 MB',
    deleteSwal: 'คุณต้องการลบข้อมูล One Account ID',
    titleEdit: 'แก้ไขข้อมูล One Account ID'
  },
  NewUpdate: {
    ReqDtm: 'วันที่ขอคำร้อง',
    text1: 'วันที่ดำเนินการ',
    text2: 'ส่งคำร้องสำเร็จ',
    text3: 'ระบบที่ขอความยินยอม',
    text4: 'หนังสือเดินทาง',
    text5: 'กรุณากรอก รายการข้อมูลที่ขอดำเนินการ',
    use: 'เลือก',
    dataRequest: 'ข้อมูลที่ขอความยินยอม',
    reason: 'เหตุผล',
    status: 'สถานะ',
    Name: 'ชื่อ นามสกุล',
    corporatenumber: 'เลขนิติบุคคล 13 หลัก',
    noteDetail: 'ระบุข้อมูลที่ขอความยินยอม',
    totalPer: 'จำนวนผู้รับ',
    announceId: 'หมายเลขประกาศ',
    announceName: 'ชื่อรายการประกาศ',
    employeecode: 'กรอกรหัสพนักงาน',
    editnamemail: 'แก้ไขข้อมูล Email',
    nameEng: 'ชื่อ (อังกฤษ)',
    delEmail: 'คุณต้องการลบข้อมูล Email',
    note1:
      'หมายเหตุ​: ข้อมูลที่ให้ความยินยอมทั้งหมดของโดเมนจะถูกลบและไม่สามารถกู้คืนได้',
    announ1: 'ส่งประกาศ',
    announ2: 'รายการส่งประกาศ',
    announ3: 'รายชื่อสำหรับส่งประกาศ',
    announ4: 'ส่งประกาศเรียบร้อย',
    announ5: 'ส่งประกาศสำเร็จ',
    announ6: 'ตรวจสอบสถานะการส่งประกาศ',
    announ7: 'รายชื่อที่สามารถส่งประกาศได้',
    announ8: 'รายชื่อที่ไม่สามารถส่งประกาศได้',
    announ9: 'ผู้ส่งประกาศ',
    Allname: 'รายชื่อที่เลือกทั้งหมด',
    DetailAnn1: 'เลือกนโยบายประกาศ',
    DetailAnn2: 'ชื่อรายการประกาศ',
    DetailAnn3: 'กรอกชื่อรายการประกาศ',
    DetailAnn4: 'หมายเลขประกาศ',
    DetailAnn5: 'กรอกหมายเลขประกาศ',
    DetailAnn6: '* หมายเหตุ หมายเลขจะปรากฏใต้คำประกาศ'
  },
  AnnounceList: {
    Title: 'ข้อมูลรายการประกาศ',
    AllData: 'ทั้งหมด',
    WaitData: 'รอการตอบกลับ',
    ErrorSendData: 'ส่งไม่สำเร็จ',
    AgreeData: 'รับทราบ'
  }
}
